"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniGameCompletedResponse = exports.MiniGameCompletedBody = exports.PlaybiteUserPatchBody = exports.PlaybiteUserFE = exports.PlaybiteUser = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
exports.PlaybiteUser = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: types_1.FTimestamp,
    updatedAt: types_1.FTimestamp,
    clientToken: zod_1.z.string(),
    coins: zod_1.z.number(),
    piggyBanks: zod_1.z.number(),
    earnedPiggyBanksFromMinigames: zod_1.z.number(),
    email: zod_1.z.string().nullable(),
});
exports.PlaybiteUserFE = exports.PlaybiteUser.omit({
    clientToken: true,
    createdAt: true,
    updatedAt: true,
});
// These are the fields that can be updated by the user's themselves
exports.PlaybiteUserPatchBody = exports.PlaybiteUser.pick({
    email: true,
}).partial();
exports.MiniGameCompletedBody = zod_1.z.object({
    gameId: zod_1.z.string(),
    gameName: zod_1.z.string(),
    points: zod_1.z.number(),
});
exports.MiniGameCompletedResponse = zod_1.z.object({
    coins: zod_1.z.number(),
    piggyBanks: zod_1.z.number(),
    reachedPiggyBanksFromMinigamesThreshold: zod_1.z.boolean(),
});
